// Auto-generated from ARTICLES_list_per_state.xlsx

export const SUPPORTED_STATES = [
  "Andhra Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Delhi",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Tamil Nadu",
  "Telangana",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal"
];

export const STATE_ARTICLES = {
  "Delhi": [
    "1 - Acknowledgement of a debt",
    "3 - Adoption",
    "4 - Declaration",
    "4 - Affidavit",
    "5 - General Agreement",
    "5 - Consent Letter",
    "5(c) - Rectification Deed- Immovable",
    "5(c) - Rectification Deed- Movable",
    "6(2)(a) - Agreement relating to deposit of title deed",
    "6(2)(b) - Agreement relating to deposit of title deed",
    "11 - Authority to Adopt",
    "11(Sch-1A) - Assignment of Debt",
    "12 - Award",
    "12 - Award - Movable",
    "12 - Award - Immovable",
    "13 - Bill of Exchange",
    "15 - Bonds",
    "17 - Cancellation of instrument",
    "17 - Cancellation of Agreement",
    "18 - Certificate of Sale",
    "19 - Certificate or other document (Shares)",
    "23 - Conveyance (M&A of Companies under Amalgamation Scheme)",
    "23 - Conveyance",
    "23 - Sale",
    "23 - Decree(Sale Deed/Conveyance)",
    "23-A - Sale Agreement",
    "25 - Additional Copy of document",
    "26 - Customs-Bonds",
    "27 - Debenture",
    "29 - Divorce",
    "31 - Exchange of property",
    "32(a) - Further Charge",
    "32(b)(i) - Further Charge",
    "32(b)(ii) - Further Charge",
    "33 - Gift",
    "34 - Indemnity Bond",
    "35 - Perpetual",
    "35(i) - Lease- Rent deed upto 1 year",
    "35(ii) - Lease upto 5 years",
    "35(ii) - Lease with security upto 5 years",
    "35(iii) - Lease upto 10 years",
    "35(iii) - Lease with security upto 10 years",
    "35(iv) - Lease upto 20 years",
    "35(iv) - Lease with security upto 20 years",
    "35(v) - Lease upto 30 years",
    "35(v) - Lease with security upto 30 years",
    "35(vi) - Lease upto 100 years",
    "35(vi) - Lease with security upto 100 years",
    "35(vii) - Lease upto 200 years",
    "35(vii) - Lease with security upto 200 years",
    "40 - Mortgage",
    "40(c) - Mortgage Collateral",
    "41 - Mortgage of a Crop",
    "45 - Partition",
    "46 - Partnership",
    "47 - Policy of Insurance",
    "48 - Power of attorney -SPA",
    "48 - GPA-Blood Relation",
    "48(c) - Power of attorney - GPA",
    "48(d) - Power of attorney - GPA more than five persons jointly and severly",
    "48(e) - Power of attorney - GPA more than five persons but less than ten\npersons",
    "48(f) - Power of attorney- GPA with consideration",
    "48(g) - Power of attorney - Authenticated GPA",
    "53 - Receipt",
    "54 - Re-conveyance",
    "54A - Record of Transaction (Electronics or Otherwise) effected by a\ntrading member (Broker Note)",
    "55 - Relinquishment Deed",
    "55 - Disclaimer",
    "55 - Release",
    "56 - Respondentia Bond",
    "57 - Security Bond",
    "58 - Settlement",
    "58 - Decree(Settlement)",
    "58 - Memorandum of Settlement",
    "59 - Share Warrants",
    "61 - Surrender of Lease",
    "62 - Transfer (with or without consideration for Debentures & Company\nShares)",
    "63 - Transfer of Lease",
    "64 - Trust",
    "64(b) - Revocation of Trust",
    "64(b) - Dissolution Deed",
    "64(b) - Deed of Retirement",
    "Others",
    "Undertaking",
    "Surety Bonds",
    "Will",
    "Will With Cancellation",
    "Will Sealed Cover",
    "Will After Death",
    "Will Medical Ground",
    "Cancellation Of Will",
    "Bank Guarantee",
    "Guarantee Bond",
    "Car Loan/ Loan Agreement",
    "Transfer Deed",
    "L.C. (Letter Certificate)",
    "Forward Contract",
    "Bond"
  ],
  "Uttar Pradesh": [
    "1 - Acknowledgement of a Debt",
    "2 - Administration Bond",
    "3 - Adoption Deed",
    "4 - Affidavit",
    "5 - Agreeement or Memorandum of an Agreement",
    "6 - Agreement relating to Deposit of Title Deeds, Pawn or Pledge",
    "7 - Appointment in Execution of a Power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship Deed",
    "10 - Articles of Association of a Company",
    "11 - Articles of Clerkship",
    "12 - Award",
    "12A - Bank Guarantee",
    "13 - Bill of Exchange",
    "15 - Bond",
    "16 - Bottomry Bond",
    "17 - Cancellation",
    "17A - Certificate of Enrolment under Section 22 of the Advocates Act,1961",
    "17B - Certificate of Practice as Notary",
    "18 - Certificate of Sale",
    "19 - Certificate or other Document",
    "20 - Charter Party",
    "22 - Composition Deed",
    "23 - Conveyance",
    "24 - Copy or Extract",
    "25 - Counterpart or Duplicate",
    "26 - Customs-Bond",
    "27 - Debenture",
    "28 - Delivery Order in respect of Goods",
    "29 - Divorce",
    "31 - Exchange or Property",
    "32 - Further Charge",
    "33 - Gift",
    "34 - Indemnity Bond",
    "34A - Instrument Correcting a purely Clerical Error",
    "35 - Lease",
    "36 - Letters of Allotment of Shares",
    "38 - Letter of License",
    "38A - Licence relating to Arms or Ammunitions",
    "39 - Memorandum of Association of a Company",
    "40 - Mortgage Deed",
    "41 - Mortgage of a Crop",
    "42 - Notarial Act",
    "43 - Note or Memorandum",
    "44 - Note of Protest by the Master of a ship",
    "45 - Partition",
    "46 - Patnership",
    "48 - Power of Attorney",
    "50 - Protest of bill or Note",
    "51 - Protest by the Master of a Ship",
    "53 - Receipt",
    "54 - Re-Conveyance of Mortgaged property",
    "55 - Release",
    "56 - Respondentia Bond",
    "57 - Security Bond or Mortgage Deed",
    "58(A) - Settlement-Instrument of (including a deed of dower",
    "58 (B) - Settlement-Revocation of",
    "59 - Share Warrants",
    "60 - Shipping Order",
    "61 - Surrender of Lease",
    "63 - Transfer of Lease",
    "64 - Trust",
    "65 - Warrant of Good",
    "Non Registerable",
    "17(A) - Certificate of Enrolment under Section 22 of the Advocates Act,1961",
    "5(C) - General Loan Agreement",
    "40 - Deed of Hypothecation",
    "4 - Affidavit (Non-Registrable)",
    "7 - Appointment in Execution of a Power (Non-Registrable)",
    "9 - Apprenticeship Deed (Non-Registrable)",
    "17(A) - Certificate of Enrolment under Section 22 of the Advocates Act,1961 (Non-Registrable)",
    "24 - Copy or Extract (Non-Registrable)",
    "5(C) - General Loan Agreement (Non-Registrable)",
    "40 - Deed of Hypothecation (Non-Registrable)",
    "34 - Indemnity Bond (Non-Registrable)",
    "38 - Letter of License (Non-Registrable)",
    "42 - Notarial Act (Non-Registrable)",
    "48 - Power of Attorney (Non-Registrable)",
    "50 - Protest of bill or Note (Non-Registrable)",
    "53 - Receipt (Non-Registrable)",
    "57 - Security Bond or Mortgage Deed (Non-Registrable)"
  ],
  "Tamil Nadu": [
    "1 - ACKNOWLEDGEMENT",
    "2 - ADMINISTRATION BOND",
    "3 - ADOPTION-DEED",
    "4 - AFFIDAVIT",
    "5 - AGREEMENT OR MEMORANDUM OF AN AGREEMENT",
    "6 - AGREEMENT RELATING TO DEPOSIT OF TITLE-DEEDS PAWN OR PLEDGE",
    "7 - APPOINTMENT IN EXECUTION OF A POWER",
    "8 - APPRAISMENT OR VALUATION",
    "9 - APPRENTICESHIP DEED",
    "10 - ARTICLES OF ASSOCIATION OF A COMPANY",
    "12 - AWARD",
    "13 - BILL OF EXCHANGE",
    "14 - BILL OF LADING",
    "15 - BOND",
    "16 - BOTTOMRY BOND",
    "17 - CANCELLATION",
    "18 - CERTIFICATE OF SALE",
    "19 - CERTIFICATE OF OTHER DOCUMENT",
    "20 - CHARTER-PARTY",
    "20-A - CHIT AGREEMENT",
    "22 - COMPOSITION DEED",
    "23 - CONVEYANCE",
    "24 - COPY OR EXTRACT",
    "25 - COUNTERPART OR DUPLICATE",
    "26 - CUSTOMS BOND-",
    "27 A - DEBENTURE \u2013 BY ENDORSEMENT",
    "27 B - DEBENTURE- BY DELIVERY",
    "28 - DELIVERY ORDER IN RESPECT OF GOODS",
    "29 - DIVORCE-",
    "30 - ENTRY AS AN ADVOCATE OR ATTORNEY ON THE ROLL OF THE MADRAS HIGH COURT",
    "31 - EXCHANGE OF PROPERTY",
    "32 - FURTHER CHARGE",
    "33 - GIFT",
    "34 - INDEMNITY-BOND",
    "35 - LEASE",
    "36 - LETTER OF ALLOTMENT OF SHARES",
    "37 - LETTER OF CREDIT",
    "38 - LETTER OF LICENCE",
    "39 - MEMORANDUM OF ASSOCIATION OF A COMPANY-",
    "40 - MORTGAGE DEED",
    "41 - MORTGAGE OF A CROP",
    "42 - NOTARIAL ACT",
    "43 - NOTE OR MEMORANDUM",
    "44 - NOTE OF PROTEST BY THE MASTER OF A SHIP",
    "45 - PARTITION",
    "46 - PARTNERSHIP",
    "47 - POLICY OF INSURANCE",
    "48 - POWER OF ATTORNEY",
    "49 - PROMISSORY NOTE",
    "50 - PROTEST OF BILL OR NOTE",
    "51 - PROTEST BY THE MASTER OF A SHIP",
    "52 - PROXY",
    "53 - RECEIPT",
    "54 - RECONVEYANCE OF MORTGAGED PROPERTY-",
    "55 - RELEASE",
    "56 - RESPONDENTIA BOND",
    "57 - SECURITY BOND OR MORTGAGE DEED",
    "58 - SETTLEMENT",
    "59 - SHARE WARRANTS",
    "60 - SHIPPING ORDER",
    "61 - SURRENDER OF LEASE",
    "62 - TRANSFER",
    "63 - TRANSFER OF LEASE",
    "64 - TRUST",
    "65 - WARRANT OF GOODS"
  ],
  "Assam": [
    "1 - ACKNOWLEDGEMENT",
    "3 - ADOPTION DEED",
    "5 - AGREEMENT OR MEMORANDUM OF AN AGREEMENT",
    "6 - AGREEMENT RELATING TO DEPOSIT OF LITTLE DEEDS, PAWN OR\nPLEDGE OR HYPOTHECATION",
    "10 - ARTICLE OF ASSOCIATION OF A COMPANY",
    "12 - AWARD",
    "15 - BOND",
    "17 - CANCELLATION",
    "18 - CERTIFICATE OF SALE",
    "23 - CONVEYANCE",
    "25 - COUNTERPART OR DUPLICATE",
    "26 - CUSTOMS BOND",
    "27 - DEBENTURE",
    "31 - EXCHANGE OF PROPERTY",
    "32 - INSTRUMENT OF FURTHER CHARGE",
    "33 - INSTRUMENT OF GIFT",
    "35 - LEASE",
    "38 - LETTER OF LICENSE,",
    "39 - MEMORANDUM OF ASSOCIATION OF A COMPANY",
    "40 - MORTGAGE DEED (DIFFERENT TYPES)",
    "45 - PARTITION",
    "46 - PARTNERSHIP",
    "48 - POWER OF ATTORNEY (DIFFERENT TYPES)",
    "54 - RE-CONVEYANCE OF MORTGAGE PROPERTY",
    "55 - RELEASE",
    "57 - SECURITY BOND OR MORTGAGE DEED",
    "58 - SETTLEMENT",
    "61 - SURRENDER OF LEASE",
    "62 - TRANSFER",
    "63 - TRANSFER OF LEASE",
    "64 - TRUST",
    "2 - Administration Bond",
    "4 - Affidavit",
    "5(c). - Agreement or Memorandum of an agreement - Agreements other than\napplicable under 5(a) and 5(b)",
    "6(a). - Agreement relating to deposit of title-deeds, pawn or pledge - If such loan or debt is repayable on demand or more than three months from the date\nof instrument evidencing the agreement",
    "6(b). - Agreement relating to deposit of title-deeds, pawn or pledge - If such loan or debt is repayable not more than three months from the date of such\ninstrument",
    "7 - Appointment for the purpose of execution of any power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship deed",
    "19 - Certificate or other document",
    "22 - Composition Deed",
    "24 - Copy or extract",
    "29 - Divorce",
    "30 - Entry as an advocate or attorney on the roll of any High Court",
    "34 - Indemnity Bond",
    "36 - Letter of allotment of shares",
    "37 - Bank Guarantee / Letter of Credit",
    "41 - Mortgage Bond",
    "42 - Notarial Act",
    "43 - Note or Memorandum",
    "44 - Note of protest by the master of ship",
    "47 - Policy of Insurance",
    "49 - Promissory Note",
    "50 - Protest of Bill or Note",
    "51 - Protest by the master of a ship",
    "56 - Respondentia Bond",
    "59 - Share Warrants",
    "65 - Warrants for goods,"
  ],
  "Gujarat": [
    "2 - Administration Bond (Stamp Duty: Rs. 300)",
    "3 - Adoption - Deed (Stamp Duty: Rs. 200)",
    "4 - Affidavit (Stamp Duty: Rs. 50)",
    "5 ( h ) - Agreement (not otherwise provided for) (Stamp Duty: Rs. 300)",
    "9 (a ) - Appointment in Execution of  Power - Trustees (Stamp Duty: Rs. 300)",
    "9 (b) - Appointment in Execution of  Power - Movable /\nImmovabl (Stamp Duty: Rs. 300)",
    "10 - Appraisement or Valuation (Stamp Duty: Rs. 300)",
    "11 - Apprenticeship Deed (Stamp Duty: Rs. 300)",
    "13 - Award (Stamp Duty: Rs. 300)",
    "16 - Cancellation (Stamp Duty: Rs. 300)",
    "19 - Composition Deed (Stamp Duty: Rs. 300)",
    "21 - Copy or Extract (Stamp Duty: Rs. 300)",
    "22 - Counter Part or Duplicate (Stamp Duty: Rs. 300)",
    "23 - Customs Bond or Excise Bond (Stamp Duty: Rs. 300)",
    "25 - Divorce (Stamp Duty: Rs. 300)",
    "29 - Indemnity Bond (Stamp Duty: Rs. 300)",
    "32 - Letter of Guarantee (Stamp Duty: Rs. 300)",
    "33 - Letter of License (Stamp Duty: Rs. 300)",
    "34 - Marriage Registration (Stamp Duty: Rs. 200)",
    "35 ( a ) - Memorandum of Association of Company (Stamp Duty: Rs. 300)",
    "38 - Notarial Act (Stamp Duty: Rs. 50)",
    "39 (g ) - Note or Memorandum - Govt. Security (Stamp Duty: Rs. 300)",
    "41 - Note of Protest by the Master of a Ship (Stamp Duty: Rs. 300)",
    "44 (2) (b ) - Partnership - Alteration (Stamp Duty: Rs. 200)",
    "44 (3) (b) - Partnership - Dissolution in any other case (Stamp Duty: Rs. 200)",
    "45 ( a ) - Power of Attorney - Registration of Document - Single T (Stamp Duty: Rs. 300)",
    "45 ( b ) - Power of Attorney - Suits - Small Cause Courts Act. (Stamp Duty: Rs. 300)",
    "45 ( c ) - Power of Attorney - Other than Article 45 (a) (Stamp Duty: Rs. 300)",
    "45 ( d ) - Power of Attorney -Not More than 5 persons (Stamp Duty: Rs. 300)",
    "45 ( e ) - Power of Attorney - More than 5 persons (Stamp Duty: Rs. 300)",
    "5 ( f ) (ii) ( a - Power of Attorney - Imovable Property (Stamp Duty: Rs. 300)",
    "45 ( h ) - Power of Attorney (in any other case) (Stamp Duty: Rs. 300)",
    "46 - Protest of Bill or Note (Stamp Duty: Rs. 300)",
    "47 - Protest by the Master of a Ship (Stamp Duty: Rs. 300)",
    "48 - Reconveyance of Mortgaged Property (Stamp Duty: Rs. 300)",
    "48- A ( a ) - Record of Transaction (Stamp Duty: Rs. 300)",
    "49 (a) - Release- Ancestral Property (Stamp Duty: Rs. 200)",
    "51 - Security Bond or Mortgage - Deed (Stamp Duty: Rs. 300)",
    "55 - Surrender of Lease (Stamp Duty: Rs. 300)",
    "56 (b) - Transfer - Interest Secured by Bond/ Mortgage Deed/\nInsurance Policy (Stamp Duty: Rs. 300)",
    "56 (c ) - Transfer - Under the Administrators Gen. Act 1963, Sec. (Stamp Duty: Rs. 300)",
    "56 (d ) - Transfer -  Trust Property(Without - Consideration) (Stamp Duty: Rs. 300)",
    "58 ( a ) - Trust - Declaration (Stamp Duty: Rs. 300)",
    "58 ( b ) - Trust -  Revocation (Stamp Duty: Rs. 300)"
  ],
  "Jammu and Kashmir": [
    "3 - Adoption Deed",
    "6 - Agreement relating to deposit of title deeds,pawn,pledge or hypothecation",
    "11 - Award",
    "14 - Cancellation of Instrument",
    "15 - Certificate of Sale",
    "18 - Conveyance",
    "25 - Exchange of Property",
    "26 - Further Charge",
    "27 - Gift Deed",
    "29(a)(i) - Lease exceeding one year",
    "35 - Mortgage deed",
    "36 - Mortgage of a Crop",
    "39 - Partition",
    "40 - Partnership",
    "42(c)&(d) - Power of Attorney authorizing sale",
    "47 - Re-conveyance",
    "48 - Release",
    "49 - Security Bond",
    "50 - Settlement",
    "53 - Surrender of Lease",
    "55 - Transfer of Lease",
    "56 - Trust-declaration or revocation",
    "Agreement to sell",
    "1 - Acknowledgement",
    "2 - Administration Bond",
    "4 - Affidavit",
    "5 - Agreement or Memorandum of an Agreement",
    "7 - Appointment in execution of a power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship deed",
    "10 - Articles of Association of a Company",
    "12 - Bill of Exchange",
    "13 - Bond",
    "16 - Certificate or other document(Shares)",
    "17 - Composition deed",
    "19 - Copy or extract",
    "20 - Counterpart or duplicate",
    "21 - Customs Bond or Excise Bond",
    "22 - Debenture",
    "23 - Delivery order in respect of goods",
    "24 - Divorce",
    "28 - Indemnity Bond",
    "29 - Lease below one year",
    "30 - Letter of allotment of Shares",
    "31 - Letter of Credit",
    "32 - Letter of Guarantee",
    "33 - Letter of Licence",
    "34 - Memorandum of Association of a Company",
    "37 - Notarial Act",
    "38 - Note or Memorandum",
    "41 - Policy of Insurance",
    "42(a),(b)&(c) - Power of Attorney without authorizing sale",
    "43 - Promissory Note",
    "44 - Protest of Bill or Note",
    "45 - Proxy",
    "46 - Receipt",
    "51 - Share Warrants",
    "52 - Shipping Order",
    "54(a) - Transfer of shares",
    "54(b) - Transfer of Debentures",
    "54(c) - Transfer of interest secured by bond, mortgage deed or policy of insurance",
    "57 - Warrant of Goods",
    "58 - Entry as an Advocate of the High Court",
    "39(c) - Instrument of partition by a Revenue Officer",
    "31 - BANK GUARANTEE / LETTER OF CREDIT"
  ],
  "Himachal Pradesh": [
    "3 - Adoption-Deed",
    "12 - Award",
    "17 - Cancellation",
    "18 - Certificate of Sale",
    "23 - Conveyance",
    "32 - Instrument of Further Charge",
    "33 - Instrument of Gift",
    "35 - Lease",
    "40 - Mortgage-Deed",
    "48 - Power of Attorney",
    "54 - Re-Conveyance of Mortgaged Property",
    "55 - Release",
    "57 - Security-Bond or Mortgage Deed",
    "58 - Instrument of Settlement",
    "61 - Surrender of Lease",
    "63 - Transfer of Lease",
    "64 - Trust",
    "1 - Acknowledgement of a debt",
    "2 - Administration Bond",
    "4 - Affidavit",
    "5 - Agreement or Memorandum of an Agreement",
    "6 - Agreement relating to Deposit of Title- Deeds, Pawn or Pledge",
    "7 - Appointment in execution of a Power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship-Deed",
    "10 - Articles of Association of a Company",
    "11 - Articles of Clerkship",
    "13 - Bill of Exchange",
    "14 - Bill of Lading (including a through bill of lading)",
    "15 - Bond",
    "16 - Bottomry Bond",
    "19 - Certificate or other Document",
    "20 - Charter Party",
    "22 - Composition-Deed",
    "23(A) - Conveyance in the Nature of Part Performance",
    "24 - Copy or Extract",
    "25 - Counterpart or Duplicate",
    "26 - Customs-Bonds",
    "27 - Debenture",
    "28 - Delivery Order in respect of Goods, Deposit of Title -Deeds",
    "29 - Instrument of Divorce",
    "30 - Entry as an Advocate, Vakil or Attorney on the Roll of the High Court",
    "31 - Instrument of Exchange of Property",
    "34 - Indemnity Bond",
    "36 - Letter of Allotment of Shares",
    "37 - Letter of Credit",
    "38 - Letter of License",
    "39 - Memorandum of Association of a Company",
    "41 - Mortgage of a Crop",
    "42 - Notarial Act",
    "43 - Note or Memorandum",
    "44 - Note of Protest by the Master of a Ship",
    "45 - Partition",
    "46 - Partnership",
    "47 - Policy of Insurance",
    "49 - Promissory Note",
    "50 - Protest of Bill or Note",
    "51 - Protest by the Master of a Ship",
    "52 - Proxy",
    "53 - Receipt",
    "56 - Respondentia Bond",
    "59 - Share Warrants",
    "60 - Shipping Order",
    "62 - Transfer",
    "65 - Warrant for Goods"
  ],
  "Karnataka": [
    "1(i)(a) - Acknowledgement of a Debt - upto Rs.5000/-",
    "1(i)(b) - Acknowledgement of a Debt - more than 5000/-",
    "37(a) - Note or memorandum of record sent by broker to his principal intimating the purchase or sale through stock exchange of any goods or commodities",
    "37(b) - Note or memorandum of record sent by broker to his principal intimating the\npurchase or sale through stock exchange of any share, scrip, stock, bond, debenture (other than Government Security)",
    "37(c) - Note or memorandum of record sent by broker to his principal intimating the purchase or sale through stock exchange of a Government Securities",
    "37(d) - Note or memorandum of record sent by broker to his principal intimating the\npurchase or sale through stock exchange other Securities",
    "37(e) - Note or memorandum of record sent by broker to his principal intimating the\npurchase or sale through stock exchange of futures and options trading of securities",
    "37(f) - Note or memorandum of record sent by broker to his principal intimating the purchase or sale through stock exchange of forward contracts commodities",
    "38 - Note of Protest by the Master of a ship",
    "40 (A) - Partnership - Constitution of Partnership",
    "40(B)(b) - Partnership - Reconstitution",
    "40A(a) - Limited Liability Partnership - Capital Upto Rs.10 lakhs",
    "41(d) - Power of Attorney - authorizing more than 5 to 10 persons to act jointly in\nmore than one transaction or generally",
    "41(f) - Power of Attorney - when given for trading operation",
    "41(g) - Power of Attorney - when given for depository participant",
    "41(h) - Power of Attorney - in any other case",
    "42 - Protest of Bill / Note",
    "43 - Protest by the Master of a Ship",
    "44 - Re-Conveyance of mortgaged property",
    "12(a) - Respondentia Bond - Amount Secured does not exceed Rs.1000",
    "47 - Security Bond or Mortgage Deed",
    "50 - Shipping",
    "51 - Surrender of Lease (Art 40b)",
    "52(a) - Transfer of debentures",
    "52(b) - Transfer any interest secured by bond or policy of insurance",
    "54(i) - Trust made for public religious and charitable purpose",
    "54(ii) - Trust made for management and custody of property where there is no\ntransfer / disposition of property",
    "55 - Warrants of Goods",
    "20(5)(i) - Conveyance - Industrial machinery treated as movable",
    "41(b) - Power of Attorney - for authorising one or more person to act in a single\ntransaction",
    "41(c) - Power of Attorney - for authorising more than 5 person to act jointly",
    "52(c) - Transfer - property under section 25 of administrator generals act 1963.",
    "18A(1) - Purchase or Sale of Government Securities - 5(b)",
    "18A(1) - Purchase or Sale of Government Securities - 37(c)",
    "18A(2) - Securities of incorporated company of other body corporate submitted to clearing house office stock exchange recognized under the Securities Contract\n(regulartion) Act, 1956. - 5(c)(i)",
    "18A(2) - Securities of incorporated company of other body corporate submitted to\nclearing house office stock exchange recognized under the Securities Contract (regulartion) Act, 1956. - 37(b)",
    "18A(3) - Securities of incorporated company or other body corporate submitted to clearing house office stock exchange not recognized under the securities\ncontract (regulation) Act, 1956. - 5(c)(i)",
    "18A(3) - Securities of incorporated company or other body corporate submitted to clearing house office stock exchange not recognized under the securities\ncontract (regulation) Act, 1956. - 37(b)",
    "5(e)(ii) - Agreement or its records or MOA - Sale of immovable property wherein part\nperformance of the contract, possession of the contract, possession of the property is not delivered",
    "5(g)(i) - Agreement or its records or MOA - Sale of moveable property, possession of\nthe property is delivered",
    "5(g)(ii) - Agreement or its records or MOA - Sale of moveable property, possession of\nthe property is not delivered",
    "5(i-d)(ii) - Agreement or its records or MOA - Agreement relating to building works or\nlabour or services Above Rs.10 lakhs",
    "15(c) - Certificate of Sale - In any other case",
    "32-A(iii) - Letter of License - 1 year to 10 year",
    "32-A(iv) - Letter of License - 10 year to 20 year",
    "32-A(v) - Letter of License - 20 to 30 year",
    "39(a)(1) - Partition - Non Agricultural property in BBMP, UDA, BMRDA, Municipal\nCouncils or Town Panchayats",
    "39(a)(2) - Partition - Other Areas",
    "39(b) - Partition - Agricultural Land",
    "39(c) - Partition - Movable Property",
    "39(d) - Partition - Combination of all above",
    "40(C) - Partnership - Dissolution",
    "40B - Limited Liability Partnership - Reconstruction or Amalgamation",
    "41(e) - Power of Attorney - Authorizing to sell property",
    "41(eb) - Power of Attorney - when sale power given to other than family members",
    "49 - Share Warrants",
    "41(a) - Power of Attorney - for admitting executing of document",
    "40(C)(b) - Partnership - Dissolution -  Immovable properties",
    "32 - Letter of licence",
    "56(i) - Bank Guarantee - If related to paper bank guarantee",
    "56(ii) - Bank Guarantee - If relating to e-bank guarantee",
    "5(i-e)(ii) - Chit Agreement - Where the value of the chit exceeds Rs.1 lakh",
    "2(a) - Administration Bond - Upto Rs.1000/-",
    "53A - Transfer of Licence",
    "2(B) - Administration Bond - In any other case",
    "6(2)(i) - Pawn or Pledge of Movable Property - Loan amount above Rs.1 lakh and upto\nRs.10 lakh",
    "8(a) - Appraisement or Valuation - Upto Rs.1000",
    "27(b)(iii) - Further charges Loan exceeding 10 Lakhs 34(d)(ii)",
    "30(1)(i) - Lease of Immovable Property - Not exceeding 1 year in case of Residential\nproperty",
    "31 - Letter of Allotment",
    "40A(b) - Limited Liability Partnership - Capital more than Rs.10 lakhs",
    "12(b) - Respondentia Bond - Amount exceeding Rs.1000",
    "3 - Adoption Deed",
    "4 - Affidavit",
    "1(ii) - Acknowledgement of Letter, Article, Package, Parcel .....",
    "5(a) - Sale of Bill Exchange",
    "5(b) - Purchase or Sale of Government Security",
    "5(c)(i) - Sale or Purchase of Shares, Stocks Bonds, Debenture Stock or other\nmarketable security between members of Stock Exchange",
    "5(c)(ii) - Agreement or its records or MOA - In any other case",
    "5(i) - Agreement relating to contract between Depository Participant and Client for\nopening Demat A/c",
    "5(i-a) - Agreement relating to Contract between Stock Broker or Sub Broker (agent)\nand client for Stock Market Operations",
    "5(i-b) - Agreement relating to Advertisement or telecasting or broadcasting of\nprograms",
    "5(i-c) - Agreement relating to assignment or transfer of intellectual property rights,\npatent rights, copy rights or trade market rights",
    "5(i-d)(i) - Agreement relating to building works or labour or services - Upto Rs.10 lakhs",
    "5(i-e)(i) - Chit Agreement - Where the value of the chit does not exceed Rs.1 lakh",
    "5(J) - Agreement (in any other cases)",
    "6(1)(i) - Agreement relating to DTD - Loan amount does not exceed Rs.10 lakhs",
    "6(1)(ii) - Agreement relating to DTD - Loan amount exceeding Rs.10 lakhs",
    "6(2)(ii) - Pawn or Pledge of Movable Property - Loan amount above Rs.10 lakhs",
    "7 - Appointment in execution of a power",
    "8(b) - Appraisement or Valuation - In any other case",
    "9 - Apprenticeship Deed",
    "10 - Articles of Association of a Company",
    "12(a) - Bond - Amount secured does not exceed Rs.1000",
    "12(b) - Bond - Amount exceeding Rs.1000",
    "13 - Bottomry Bond",
    "15(a) - Certificate of Sale - Purchase money does not exceed Rs.10",
    "15(b) - Certificate of Sale - Purchase money does not exceed Rs.25",
    "16 - Certificate evidencing right or title of the holder thereof, or any other person, either to any share, scrip or stock in or of any incorporated company",
    "17 - Certificate of Enrolment as Advocate",
    "18 - Charter Party",
    "19 - Composition Deed",
    "21 - Copy of Extract",
    "22 - Counter part or Duplicate",
    "23 - Customs Bond or Excise Bond Art 23(b)",
    "24 - Delivery order in respect of Goods",
    "25 - Divorce",
    "27(b)(iii) - Further charges Hypothecation of Movable property loan upto 10 Lakhs\n34(d)(i)",
    "29 - Indemnity Bond (As per Article 47)",
    "30(1)(ii) - Lease of Immovable Property - Not exceeding 1 year in case of commercial\nindustrial property",
    "30(2) - Lease of Movable Property - Lease of movable property rent fixed, no\npremium30(2)(a)(i)upto 10 years",
    "30(2)(a)(ii) - Lease of Movable Property - Above 10 years",
    "30(2)(b) - Lease of Movable Property - Lease granted for fine or premium but no rent",
    "30(2)(c) - Lease of Movable Property - Lease for fine premium and also rent",
    "32-A (i) - Letter of License - Not more than 1 year in case of residential property",
    "32-A(ii) - Letter of License - Not more than 1 year in case of commercial industrial\nproperty",
    "33 - Memorandum of Association of a company",
    "34(d)(i) - Mortgage Deed - Hypothecation of movable property loan upto Rs.10 lakh",
    "34(d)(ii) - Mortgage Deed - loan exceeding 10 lakhs"
  ],
  "Odisha": [
    "IA-5(2) - Agreement",
    "IA-57 - Security Bond",
    "5(c) - Agreement to Memorandum of an agreement if not otherwise provided for",
    "IA-4 - Affidavit",
    "IA-5(1) - Memorandum of an Agreement",
    "IA-6 - Agreement relating to deposit of Title Deeds",
    "IA-7 - Appointment in execution of Power",
    "IA-15 - Bond",
    "IA-17 - Cancellation Deed",
    "IA-18 - Certificate of Sale",
    "IA-22 - Composition Deed",
    "IA-23(1) - Sale Deed",
    "IA-23(2) - Conveyance Deed(immovable property)",
    "IA-23(3) - Conveyance Deed(movable property)",
    "IA-25 - Counterpart or Duplicate deed",
    "IA-26 - Customs Bond",
    "IA-27 - Debenture",
    "IA-31 - Exchange Deed",
    "IA-48 - Power of Attorney Deed",
    "IA-53 - Receipt Deed",
    "IA-54 - Reconveyance of Mortgaged Property",
    "IA-55 - Release Deed",
    "IA-58 - Settlement Deed",
    "IA-58B - Revocation of settlement",
    "IA-61 - Surrender of Lease Deed",
    "IA-63 - Transfer of Lease",
    "IA-32 - Further Charge",
    "IA-34 - Indemnity Bond",
    "IA-35(1) - Lease Deed",
    "IA-35(2) - Hire Agreement",
    "IA-35(3) - Agreement to Lease",
    "IA-40 - Mortgage Deed",
    "IA-41 - Mortgage of a Crop",
    "IA-45 - Partition Deed",
    "IA-56 - Respondentia Bond",
    "IA-62 - Transfer Deed",
    "IA-64 - Trust",
    "IA-64B - Revocation of Trust",
    "Will",
    "IA-2 - Administration Bond",
    "IA-8 - Appraisement or valuation",
    "IA-9 - Apprenticeship deed",
    "IA-10 - Articles of Association of a Company",
    "IA-16 - Bottomry Bond",
    "IA-19 - Certificate of other document",
    "IA-24 - Copy or Extract",
    "IA-29 - Divorce",
    "IA-20 - Charter Party",
    "IA-38 - Letter of License",
    "IA-39 - Memorandum of association of a Company",
    "IA-42 - Notarial Act",
    "IA-43 - Note or Memorandum",
    "IA-44 - Note of Protest by the master of a ship",
    "IA-46(A) - Instrument of Partnership",
    "IA-46(B) - Dissolution of Partnership",
    "IA-50 - Protest of bill or note",
    "IA-51 - Protest by the master of a ship",
    "IA-59 - Share Warrants",
    "IA-65 - Warrants of Goods",
    "IA-3 - Adoption Deed",
    "IA-23(2) - Agreement to Sale",
    "IA-23(3) - Conveyance Deed",
    "IA-23(4) - Assignment Deed",
    "IA-33 - Gift Deed",
    "IA-35 - Lease Deed",
    "IA-39 - Mortgage deed without possession/Hypothecation Deed",
    "IA-1 - Acknowledgement",
    "IA-11 - Articles of clerkship",
    "IA-12 - Award",
    "IA-13 - Bill of Exchange",
    "IA-14 - Bill of lading",
    "IA-28 - Delivery order in respect of goods",
    "IA-36 - Letter of allotment of shares",
    "IA-47 - Policy of Insurance",
    "IA-52 - Proxy",
    "IA-37 - Letter of Credit/Bank Guarantee",
    "IA-48 - Power Of Attorney Without Power To Sale Any Immovable Property And\nWithout Physical Transfer Of Possession Of Any"
  ],
  "Puducherry": [
    "1 - ACKNOWLEDGEMENT",
    "2 - ADMINISTRATION-BOND",
    "3 - ADOPTION-DEED",
    "4 - AFFIDAVIT",
    "5 - AGREEMENT OR MEMORANDUM OF AGREEMENT",
    "6 - AGREEMENT RELATING TO DEPOSIT OF TITLE DEEDS,\nPAWN OR PLEDGE",
    "7 - APPOINTMENT IN EXECUTION OF A POWER",
    "8 - APPRAISEMENT OR VALUATION",
    "9 - APPRENTICESHIP DEED",
    "10 - ARTICLES OF ASSOCIATION OF A COMPANY",
    "11 - ARTICLES OF CLERKSHIP",
    "12 - AWARD",
    "13 - BILL OF EXCHANGE",
    "14 - BILL OF LADING",
    "15 - BOND",
    "16 - BOTTOMRY BOND",
    "17 - CANCELLATION",
    "18 - CERTIFICATE OF SALE",
    "19 - CERTIFICATE OR OTHER DOCUMENT",
    "20 - CHARTER-PARTY",
    "22 - COMPOSITION-DEED",
    "23 - CONVEYANCE",
    "23 (A) - CONVEYANCE IN THE NATURE OF PART PERFORMANCE",
    "24 - COPY OR EXTRACT",
    "25 - COUNTERPART OR DUPLICATE",
    "26 - CUSTOMS BOND",
    "27 - DEBENTURE",
    "28 - DELIVERY- ORDER IN RESPECT OF GOODS",
    "29 (I) - DIVORCE",
    "29 (II) - DOWER",
    "29 (III) - DUPLICATE",
    "30 - ENTRY AS AN ADVOCATE VAKIL OR ATTORNEY ON THE\nROLL OF ANY HIGH COURT",
    "31 - EXCHANGE OF PROPERTY",
    "32 - FURTHER CHARGE",
    "33 (I) - GIFT",
    "33 (II) - HIRING AGREEMENT",
    "34 (I) - INDEMNITY-BOND",
    "34 (II) - INSPECTORSHIP-DEED",
    "34 (III) - INSURANCE",
    "35 - LEASE-MORE THAN ONE YEAR",
    "35 - LEASE-NOT EXCEEDING ONE YEAR",
    "36 - LETTER OF ALLOMENT OF SHARES",
    "37 (I) - LETTER OF CREDIT",
    "37 (II) - LETTER OF GUARANTEE",
    "38 - LETTER OF LICENCE",
    "39 - MEMORANDUM OF ASSOCIATION OF A COMPANY",
    "40 - MORTGAGE-DEED",
    "41 - MORTGAGE OF A CROP",
    "42 - NOTARIAL ACT",
    "43 - NOTE OF MEMORANDUM",
    "44 (I) - NOTE OF PROTEST BY THE MASTER OF A SHIP",
    "44 (II) - ORDER FOR THE PAYMENT OF MONEY",
    "45 - PARTITION",
    "46 (A) - PARTNERSHIP",
    "46 (B) - DISSOLUTION OF PAWN OR PLEDGE",
    "47 - POLICY OF INSURANCE",
    "48 - POWER OF ATTORNEY",
    "49 - PROMISSORY NOTE",
    "50 - PROTEST OF BILL OR NOTE",
    "51 - PROTEST BY THE MASTER OF A SHIP",
    "52 - PROXY",
    "53 - RECEIPT",
    "54 - RECONVEYANCE OF MORTGAGED PROPERTY",
    "55 - RELEASE",
    "56 (I) - RESPONDENTIA BOND",
    "56 (II) - REVOCATION OF ANY TRUST OR SETTLEMENT",
    "57 - SECURITY BOND OR MORTGAGE DEED",
    "58 - SETTLEMENT",
    "59 - SHARE WARRANTS",
    "60 - SHIPPING ORDER",
    "61 - SURRENDER OF LEASE",
    "62 - TRANSFER",
    "63 - TRANSFER OF LEASE",
    "64 (I) (A) - TRUST: DECLARATION OF",
    "64 (I) (B) - TRUST: REVOCATION OF",
    "64 (II) - VALUATION",
    "64 (III) - VAKIL",
    "65 - WARRANT FOR GOODS"
  ],
  "Punjab": [
    "1 - Acknowledgement of a debt",
    "2 - Administration Bond",
    "3 - Adoption-Deed",
    "4 - Affidavit",
    "5(a) - Agreement of Memorandum of an Agreement - if relating to the sale of a bill of\nexchange",
    "5(b) - Agreement of Memorandum of an Agreement - if relating to the sale of a\nGovernment security or share in an incorporated company or other body corporate",
    "5(c) - Agreement of Memorandum of an Agreement - if relating to the sale of immovable\nproperty",
    "5(cc) - Agreement of Memorandum of an Agreement - in the case of agreement to sell\nfollowed by or evidencing delivery of possession of the immovable property agreed to be sold",
    "5(d) - Agreement - if not otherwise provided for",
    "6 - Agreement relating to deposit of title deeds, pawn or pledge, mortgage by way of\ndeposit of Title Deed (Equitable Mortgage) and hypothecation",
    "7 - Appointment in Execution of a Power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship-Deed",
    "10 - Articles of Association of a Company",
    "11 - Articles of Clerkship",
    "12 - Award",
    "13 - Bill of Exchange",
    "14 - Bill of Lading (including a through bill of lading)",
    "15 - Bond",
    "16 - Bottomary Bond",
    "17 - Cancellation",
    "18 - Certificate of Sale",
    "19 - Certificate of other Document",
    "20 - Charter Party",
    "22 - Composition-Deed",
    "23 - Conveyance",
    "24 - Copy or Extract",
    "25 - Counterpart or Duplicate",
    "26 - Customs-Bonds",
    "27 - Debenture",
    "28 - Delivery order in respect of goods, deposit of title deeds",
    "29 - Divorce",
    "30 - Entry as an Advocate, Vakil or Attorney on the roll of the High Court",
    "31 - Exchange of Property",
    "32 - Further Charge",
    "33 - Gift",
    "34 - Indemnity Bond",
    "35 - Lease",
    "36 - Letter of Allotment of Shares",
    "37 - Letter of Credit",
    "38 - Letter of License",
    "39 - Memorandum of Association of a Company",
    "40 - Mortgage Deed",
    "41 - Mortgage of a Crop",
    "42 - Notarial Act",
    "43 - Note or Memorandum",
    "44 - Note of Protest by the Master of a Ship",
    "45 - Partition",
    "46 - Partnership",
    "47 - Policy of Insurance",
    "48 - Power of Attorney",
    "49 - Promissory Note",
    "50 - Protest of Bill or Note",
    "51 - Protest by the Master of a Ship",
    "52 - Proxy",
    "53 - Receipt",
    "54 - Reconveyance of Mortgaged Property",
    "55 - Release",
    "56 - Respondentia Bond",
    "57 - Security-Bond or Mortgage Deed",
    "58 - Settlement",
    "59 - Share Warrants",
    "60 - Shipping Order",
    "61 - Surrender of Lease",
    "62 - Transfer",
    "63 - Transfer of Lease",
    "64 - Trust",
    "65 - Warrant for Goods"
  ],
  "Uttarakhand": [
    "1 - Acknowledgment of a debt",
    "2 - Administration Bond",
    "3 - Adoption - Deed",
    "4 - Affidavit",
    "5 - Agreement or Memorandum of an agreement",
    "6 - Agreement relating to Deposit of Title-Deeds, pawn or Pledge",
    "7 - Appointment in execution of a power",
    "8 - Appraisement or Valuation",
    "9 - Apprenticeship - Deed",
    "10 - Articles of Association of a Company",
    "11 - Articles of Clerkship",
    "12 - Award",
    "12(A) - Bank Guarantee",
    "13 - Bill of Exchange",
    "14 - Bill of Lading",
    "15 - Bond",
    "16 - Bottomry Bond",
    "17 - Cancellation",
    "17(A) - Certificate of enrolment of Advocates",
    "17(B) - Certificate of Practice as Notary",
    "18 - Certificate of Sale",
    "19 - Certificate or other Document",
    "20 - Charter Party",
    "22 - Composition - Deed",
    "23 - Conveyance",
    "24 - Copy or Extract",
    "25 - Counterpart or Duplicate",
    "26 - Customs - Bonds",
    "27 - Debenture",
    "28 - Delivery order in respect of Goods",
    "29 - Divorce",
    "31 - Exchange of Property",
    "32 - Further Charge",
    "33 - Gift",
    "34 - Indemnity Bond",
    "34(A) - Instrument",
    "35 - Lease",
    "36 - Letter of Allotment of Shares",
    "37 - Letter of Credit",
    "38 - Letter of License",
    "38(A) - License",
    "39 - Memorandum of Association of a Company",
    "40 - Mortgage - Deed",
    "41 - Mortgage of a Crop",
    "42 - Notarial Act",
    "43 - Note or Memorandum",
    "44 - Note of Protest",
    "45 - Partition",
    "46(A) - Partnership",
    "46(B) - Dissolution of Partnership",
    "47 - Policy of Insurance",
    "48 - Power of Attorney",
    "49 - Promissory Note",
    "50 - Protest of Bill or note",
    "51 - Protest by the Master of a Ship",
    "52 - Proxy",
    "53 - Receipt",
    "54 - Re-Conveyance of Mortgaged property",
    "55 - Release",
    "56 - Respondentia Bond",
    "57 - Security-Bond or Mortgage Deed",
    "58(A) - Settlement",
    "58(B) - Revocation of Settlement",
    "59 - Share Warrants",
    "60 - Shipping Order",
    "61 - Surrender of Lease",
    "62 - Transfer",
    "63 - Transfer of Lease",
    "64(A) - Trust",
    "64(B) - Revocation of Trust",
    "65 - Warrant for Goods",
    "Miscellaneous"
  ],
  "Maharashtra": [],
  "Madhya Pradesh": [],
  "West Bengal": [],
  "Haryana": [],
  "Chhattisgarh": [],
  "Andhra Pradesh": [],
  "Rajasthan": [],
  "Kerala": [],
  "Telangana": [],
  "Bihar": []
};
